// import templateCompiler from './template.art';
// TODO FOXIT 修改文件toolbar模板
import templateCompiler from './fwTemplate.art'
//import './toolbar.convert.scss'
//import bindCallbacks from '../callbacks';

// export default function FileModule() {
//     //let callbacks = bindCallbacks(CONVERT_LIST, callback);
//     let fragments = [];
//     return {fragments};
// }

import { 
    FILE_MAP,
    FILE_PROPERTIES_GROUP_IN_HOME
} from "../constants/file.constants";

const template = templateCompiler(FILE_MAP);
export default function FileModule() {
    //let callbacks = bindCallbacks(CONVERT_LIST, callback);
    let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;
    let fragments = [
        {
            // 向末尾追加控件
            action: ACTIONS.BEFORE,
            // 目标控件名称， 控件将被添加这个空间里面，必须确保它是一个容器类型的控件
            target: 'home-tab',
            // 定义控件的以及图标，文字等信息
            template: '<gtab text="phantom_online:toolbar.tabs.file.title" name="file-tab" group="toolbar-tab" body="fv--file-tab-paddle"></gtab>',
        },
        {
            action: ACTIONS.APPEND,
            target: 'toolbar-tab-bodies',
            template: template,
        },
      {
        // to remove 'file-properties' group which is in home tab
        action: ACTIONS.REMOVE,
        target: FILE_PROPERTIES_GROUP_IN_HOME
      }
      //...callbacks,
    ];
    return {fragments};
}